import script from "./TopHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TopHeader.vue?vue&type=script&setup=true&lang=js"

import "./TopHeader.vue?vue&type=style&index=0&id=2dc53dce&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dc53dce"]])

export default __exports__